import {Component, Inject, Optional, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-trams-invoice-component-modal',
    templateUrl: './trams-invoice-modal.component.html',
    standalone: false
})
export class TramsInvoiceModalComponent implements OnInit {
  constructor(
    @Optional() public dialogRef: MatDialogRef<TramsInvoiceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    if (!this.data) {
      console.error('Data is missing');
    }
  }

  public closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close(false);
    }
  }
}
